import React from 'react'
import styled, { css } from 'styled-components'
import sitelogo from './img/logo.png';

import rem from '../../utils/rem'

const Logo = styled.div`
  display: inline-block;
  vertical-align: middle;
  box-sizing: border-box;

  background-position: center;
  background-size: contain;

  ${p => p.compact ? css`
    background-image: url(${sitelogo});
    width: ${rem(100)};
    height: ${rem(30)};
    background-repeat: no-repeat;
  ` : css`
    background-image: url(${sitelogo});
    width: ${rem(164)};
    height: ${rem(40)};
    background-repeat: no-repeat;
  `}
`

export default Logo



// WEBPACK FOOTER //
// ./src/components/Nav/Logo.js